<!-- <flx-app-bar title="{{title$ | async }}"></flx-app-bar> -->
<div class="flow-action-shell">
	<ng-container *ngIf="showTabs">
		<flx-tabs [tabs]="dynamicTabs" [currentStep$]="currentTab$" [externalPages]="true" (outputEventStream)="selectTab($event)"></flx-tabs>
	</ng-container>
	<!--Warning goes here-->
	<flx-dynamic-loader dynamicLoaderHost></flx-dynamic-loader>
</div>
